module.exports = __webpack_public_path__ + "img/arrecredihome4v_1.be98ea32.webp";